import { Injectable } from '@angular/core';
import { SessionService } from '../session/session.service';
import { BalanceService } from '../../balance/balance.service';
import { TicketHistoryService } from '../ticket-history/ticket-history.service';
import { GameInfo } from '../../domain/signals/game-info';
import { Router } from '@angular/router';
import { WinningPlan } from '../../domain/winning-plan';

@Injectable()
export class DrawingService {

    timeouts: any[] = [];

    constructor(public sessionService: SessionService,
                public balanceService: BalanceService,
                public ticketHistoryService: TicketHistoryService,
                public router: Router) {
    }

    public startDrawing(gameInfo: GameInfo, secondsSinceEvent: number = 0) {

        setTimeout(() => {
            this.balanceService.updateBalance();
            this.ticketHistoryService.fetchHistory();
        }, 2000);

        if (gameInfo.State === GameInfo.States.DRAWING) {
            this.sessionService.currentBingoGameId = gameInfo.Game.BingoGameID;
            this.sessionService.winner = false;
            this.clearOldTimeouts();
            this.sessionService.countdown.stop();
            this.router.navigate(['/game-view']);
            this.sessionService.numbers = [];

            let balls: number[] = this.generateBalls(gameInfo.Game.Drawn, gameInfo.Game.Extra);
            let timePerBall: number = this.sessionService.settings.animationTime / balls.length;

            if (secondsSinceEvent > 0) {
                let amountOfSkippedBalls: number = Math.floor(secondsSinceEvent * 1000 / timePerBall);
                let skippedBalls = balls.splice(0, amountOfSkippedBalls);
                skippedBalls.forEach((ball: number) => {
                    this.sessionService.addNumber(ball);
                });
                timePerBall -= secondsSinceEvent;
            }
            balls.forEach((ball: number, idx: number) => {
                this.timeouts.push(setTimeout(() => this.sessionService.addNumber(ball), timePerBall * (idx + 1)));
            });

            this.timeouts.push(setTimeout(() => this.showWinningAnimation(), timePerBall * balls.length + 2000));
        }
    }

    public generateBalls(drawn: string, extra: string): number[] {
        return (drawn + (extra ? (',' + extra) : '')).split(',').map(ball => +ball.trim());
    }

    public clearOldTimeouts(): void {
        this.timeouts.forEach(to => clearTimeout(to));
        this.timeouts = [];
    }

    public showWinningAnimation() {
        this.sessionService.tickets.filter(tip => {
            let wp: WinningPlan = this.sessionService.winningPlan.filter(wp => wp.amount === tip.numbers.length)[0];
            let hits: number = this.sessionService.numbers.filter((n: number) => tip.numbers.indexOf(n) > -1).length;

            if (wp.prices.filter(price => price.hits === hits).length > 0) {
                this.sessionService.winner = true;
            }
        });
    }

}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/drawing/drawing.service.ts